import React, { useEffect, useState } from 'react';
import { Button, Select, Space, Table, Typography } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import orderQuotationService from '../../services/OrderQuotationService';
import securityService from '../../services/SecurityService';
import { useLocation, useNavigate } from 'react-router-dom';
import './orderQuotation.css';
import { convertToLocal } from '../../components/Functions/convertToLocal';
import { useAuth } from '../../hooks/useAuth';
const { Title } = Typography;

const OrderQuotationList = () => {
  const [orderQuotationList, setOrderQuotationList] = useState([]);
  const [intervalTime, setIntervalTime] = useState(10000); // Default interval of 1 second
  const [loading, setLoading] = useState(false);
  const [securities, setSecurities] = useState([]);
  const [selectedSecurityCode, setSelectedSecurityCode] = useState();
  const { showNotification } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Table columns
  const tableColumns = [
    {
      title: 'Security Code',
      dataIndex: 'securityCode',
      key: 'securityCode',
    },
    {
      title: 'Total Buy Quantity',
      dataIndex: 'totalBuyQuantity',
      key: 'totalBuyQuantity',
      align: 'right',
      render: text => Number(text).toLocaleString('en-US'),
    },
    {
      title: 'Buy Quantity',
      dataIndex: 'buyQuantity',
      key: 'buyQuantity',
      align: 'right',
      render: text => Number(text).toLocaleString('en-US'),
    },
    {
      title: 'Price',
      dataIndex: 'price',
      key: 'price',
      align: 'right',
      render: text => Number(text).toLocaleString('en-US'),
    },
    {
      title: 'Sell Quantity',
      dataIndex: 'sellQuantity',
      key: 'sellQuantity',
      align: 'right',
      render: text => Number(text).toLocaleString('en-US'),
    },
    {
      title: 'Total Sell Quantity',
      dataIndex: 'totalSellQuantity',
      key: 'totalSellQuantity',
      align: 'right',
      render: text => Number(text).toLocaleString('en-US'),
    },
    {
      title: 'Update Date',
      dataIndex: 'updateDate',
      key: 'updateDate',
      align: 'right',
      render: (_, record) => convertToLocal(record.updateDate),
    },
  ];

  const loadSecurities = async () => {
    const response = await securityService.getSecurities();
    console.log(response.securityDataList);
    setSecurities(
      response.securityDataList.sort(function (a, b) {
        if (a.companyName < b.companyName) {
          return -1;
        }
        if (a.companyName > b.companyName) {
          return 1;
        }
        return 0;
      }),
    );
    console.log(response.securityDataList[0].securityCode);
    setSelectedSecurityCode(response.securityDataList[0].securityCode);
  };

  const loadData = async () => {
    console.log(selectedSecurityCode);
    if (selectedSecurityCode) {
      setLoading(true);
      const response = await orderQuotationService.getOrderQuotation({
        securityCode: selectedSecurityCode,
      });
      setLoading(false);
      if (response.success) {
        setOrderQuotationList(response.orderQuotationList);
      } else {
        showNotification('error', response.message);
      }
    }
  };

  // useEffect(() => {
  //   loadData();
  // }, []);

  // Effect hook to schedule interval refresh
  useEffect(() => {
    // Fetch data initially
    loadSecurities();
  }, []);

  useEffect(() => {
    loadData();
  }, [selectedSecurityCode]);

  // Function to handle interval change
  const handleIntervalChange = value => {
    setIntervalTime(value);
  };

  const handleSecuritiesChange = value => {
    setSelectedSecurityCode(value);
  };

  return (
    <>
      <section className="title-bar">
        <Title level={4} className="title-text">
          Order Quotation List
        </Title>
        <div className="dropdown-wrapper">
          {securities?.length > 0 && securities[0].securityCode ? (
            <Select
              defaultValue={securities[0].companyName}
              onChange={handleSecuritiesChange}
              className="securities"
            >
              {securities.map((item, index) => (
                <Select.Option key={index} value={item.securityCode}>
                  {item.companyName}
                </Select.Option>
              ))}
            </Select>
          ) : null}
          {/* <Select defaultValue={10000} onChange={handleIntervalChange}>
            <Select.Option value={10000}>10 second</Select.Option>
            <Select.Option value={30000}>30 seconds</Select.Option>
            <Select.Option value={50000}>50 seconds</Select.Option>
          </Select> */}

          <Button
            type="primary"
            size={'middle'}
            icon={<ReloadOutlined />}
            onClick={() => loadData()}
            className="refresh-btn"
          >
            Refresh
          </Button>
        </div>
      </section>
      <Table
        rowClassName={record => (record.isMarketPrice ? 'custom-colored-row' : '')}
        columns={tableColumns}
        dataSource={orderQuotationList}
        bordered
        size={'large'}
        scroll={{
          x: 'max-content',
        }}
        pagination={false}
        loading={loading}
      />
    </>
  );
};

export default OrderQuotationList;
